export const setUkrainian = (  ) => {
    return {
        type: 'ua', 
    };
};

export const setEnglish = (  ) => {
    return {
        type: 'eng', 
    };
};
